// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__2YMME","title":"card_title__2NMcL","inActive":"card_inActive__UUi98"};